module.exports = __webpack_public_path__ + "img/back02_sp.81382dca.jpg";